<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="
        [
          'welcomeOffers',
          'welcomeModel_pv',
          'showModel_pv',
          'showSession',
          'showEvaluation',
          'showContract',
          'showAttribution'
        ].indexOf($route.name) < 1  
      "
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
      :permanent="!$vuetify.breakpoint.lgAndDown"
    >
      <!-- Barre de statut connexion -->
      <detected-speed style="height: 4px; position: absolute; top: 0; left: 0; right: 0; z-index: 10;" :width="$vuetify.breakpoint.width">
        <div slot="fast">
          <div class="online">
            <span>&nbsp;</span>
          </div>
        </div>
        <div slot="slow">
          <div class="offline">
            <span>&nbsp;</span>
          </div>
        </div>
      </detected-speed>

      <!-- Section profil avec image -->
      <v-img :aspect-ratio="16/9" :src="require('@/assets/profile.jpg')" height="140px" class="profile-image">
        <div class="d-flex fill-height  align-center justify-center">
          <v-card :class="getProfileBackground(profile)" flat>
            <v-card-text class="text-center pa-4">
              
              <!-- Profil 2: Opérateur -->
              <div v-if="profile == 2">
                <div class="text-subtitle-2 font-weight-bold mb-2">
                Candidat/</br>Soumissionnaire
                </div>
                
                <div class="text-caption font-weight-medium mb-1">
                  <b>Secteur d'activité :</b>
                </div>
                <div v-for="el in user_data.activitys" :key="el.id" class="text-caption">
                  {{ el.name }}
                </div>
               
              </div>

              <!-- Informations communes -->
              <div class="text-caption">
                REF: <span class="font-weight-bold text-uppercase">{{ getProfilePrefix(profile) }}-{{ user_data.username }}</span>
              </div>
              <div class="text-caption">
                NOM : {{ user_data ? user_data.firstname : (user_data.company ? user_data.company.name : '') }}
              </div>
              <div v-if="user_data.country" class="text-caption">
                PAYS: {{ user_data.country }}
              </div>

            </v-card-text>
          </v-card>
        </div>
      </v-img>

      <!-- Menu navigation par profil -->
      <v-list v-if="profile == 3">
        <template v-for="item in items">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-list-item-title>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-list v-if="profile == 1">
        <template v-for="item in adminRoutes">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-list v-if="profile == 2">
        <template v-for="item in opRoutes">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <v-list v-if="profile == 4">
        <template v-for="item in comRoutes">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <!-- Autorité de contrôle -->
      <v-list v-if="profile == 6">
        <template v-for="item in autorityControlRoutes">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

      <!-- Autorité de regulation -->
      <v-list v-if="profile == 5">
        <template v-for="item in autorityRegulationRoutes">
          <v-list-group
            v-if="item.children"
            :key="item.text"
            v-model="item.model"
            :prepend-icon="item.model ? item.icon : item['icon-alt']"
            append-icon
          >
            <template v-slot:activator>
              <v-list-item-content>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </v-list-item-content>
            </template>
            <v-list-item v-for="(child, i) in item.children" :key="i" link>
              <v-list-item-action v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ child.text }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>
          <v-list-item exact v-else :key="item.text" link :to="item.route">
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                </template>
                <span>{{ item.text }}</span>
              </v-tooltip>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>

    </v-navigation-drawer>

    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="white" light>
      <v-app-bar-nav-icon
        v-if="$vuetify.breakpoint.lgAndDown"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-divider vertical></v-divider>
      <v-toolbar-side-icon>
        <v-img src="@/assets/logo.png" height="50px" width="60px"> </v-img>
      </v-toolbar-side-icon>
      <v-divider vertical></v-divider>
      <v-toolbar-title class="ml-2">
        <span class="hidden-sm-and-down">ICP-E-PROCUREMENT</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon to="/">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" dark v-bind="attrs" v-on="on">
              mdi-home
            </v-icon>
          </template>
          <span>Accueil (Permet d'aller à la page d'accueil)</span>
        </v-tooltip>
      </v-btn>
      <v-divider vertical></v-divider>
      <v-btn icon to="/dashboard">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="primary" dark v-bind="attrs" v-on="on">
              mdi-view-dashboard
            </v-icon>
          </template>
          <span> Tableau de bord (Permet de retourner à la page active de travail)</span>
        </v-tooltip>
      </v-btn>
      <v-divider vertical></v-divider>
      <v-menu v-model="menu" :close-on-content-click="true" :nudge-width="200" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn light icon class="mr-2" v-bind="attrs" v-on="on">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="primary" dark v-bind="attrs" v-on="on">
                  mdi-account-circle
                </v-icon>
              </template>
              <span>Autres configurations pouvant être faite par l'utilisateur</span>
            </v-tooltip>
          </v-btn>
        </template>
        <v-card>
          <v-list>
            <v-list-item>
              <v-list-item-avatar>
                <v-icon small>mdi-account-circle</v-icon>
              </v-list-item-avatar>

              <v-list-item-content>
                {{ user_data ? user_data.firstname : (user_data.company ? user_data.company.name : '') }}
              </v-list-item-content>

              <v-list-item-action>
                <v-icon color="green darken-3">mdi-circle</v-icon>
              </v-list-item-action>
            </v-list-item>
          </v-list>

          <v-divider></v-divider>
          <v-list v-if="profile == 3">
            <template v-for="item in LogPop">
              <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-wrap">{{ item.text }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(child, i) in item.children" :key="i" link>
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item exact v-else :key="item.text" link :to="item.route">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-list v-if="profile == 2">
            <template v-for="item in OtherPop">
              <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(child, i) in item.children" :key="i" link>
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item exact v-else :key="item.text" link :to="item.route">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-list v-if="profile == 4 ">
            <template v-for="item in PopMembreCommission">
              <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(child, i) in item.children" :key="i" link>
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item exact v-else :key="item.text" link :to="item.route">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-list v-if="profile == 5">
            <template v-for="item in PopOrgReg">
              <v-list-group
                v-if="item.children"
                :key="item.text"
                v-model="item.model"
                :prepend-icon="item.model ? item.icon : item['icon-alt']"
                append-icon
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-subtitle>{{ item.text }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(child, i) in item.children" :key="i" link>
                  <v-list-item-action v-if="child.icon">
                    <v-icon>{{ child.icon }}</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>{{ child.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-item exact v-else :key="item.text" link :to="item.route">
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="h6" v-bind="attrs" v-on="on">{{ item.text }}</span>
                    </template>
                    <span>{{ item.text }}</span>
                  </v-tooltip>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
          <v-card-actions>
            <v-btn @click="logOut" color="red darken-3" text block>
              <span>Se déconnecter</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </v-app-bar>
    <v-main class="bg">
      <v-container fluid ma-0 pa-0 fill-height class="bg">
        <v-row class="pa-2"></v-row>
        <v-layout
          :class="{
            'px-0 py-0': $vuetify.breakpoint.smAndDown,
            'px-5 py-1': $vuetify.breakpoint.mdAndUp
          }"
          child-flex
        >
          <v-expand-transition>
            <div>
              <v-row class="text-left my-2" align="start" justify="left">
                <v-breadcrumbs :items="breadCrumbs" divider=">">
                  <template v-slot:item="props">
                    <router-link :to="props.item.href" v-if="!props.item.disabled">
                      <v-breadcrumbs-item :class="[props.item.disabled && 'disabled']">
                        {{ props.item.text.toUpperCase() }}
                      </v-breadcrumbs-item>
                    </router-link>
                    <v-breadcrumbs-item :class="[props.item.disabled && 'disabled']" v-else>
                      {{ props.item.text }}
                    </v-breadcrumbs-item>
                  </template>
                </v-breadcrumbs>
              </v-row>

              <router-view :key="this.$route.path"></router-view>
            </div>
          </v-expand-transition>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DetectedSpeed from "vue-identify-network";

export default {
  components: {
    DetectedSpeed
  },
  data: () => ({
    user: null,
    profile: 0,
    user_data: [],
    fav: true,
    menu: false,
    message: false,
    hints: true,
    dialog: false,
    drawer: null,
    LogPop: [
      {
        icon: "mdi-briefcase-account-outline",
        text: "Configuration des membres de la commission d'ouverture, d'évaluation (Offres /Propositions /Plis) et de négociation",
        route: { name: "commission" }
      },
      {
        icon: "mdi-file-document-multiple",
        text: "Consulter, télécharger et répondre aux demandes d'éclaircissements",
        route: { name: "request" }
      },
      {
        icon: "mdi-account-supervisor-circle",
        text: "Programmation, invitation et publication du PV des visites de sites",
        route: { name: "visit" }
      },
      { icon: "mdi-devices",
       text: "Programmation, invitation et publication du PV des conférences préalables ",
        route: { name: "meeting" } 
      },
      { 
        icon: "mdi-forum",
        text: "Réception et réponses aux demandes de  renseignements (Contacts)",
        route: { name: "message" }
       },
      {
        icon: "mdi-account-cog",
        text: "Configuration, modification et mise à jour des informations sur la page d'accueil",
        route: { name: "Config" }
      },
      {
        icon: "mdi-alpha-m-box",
        text: "Création, modification et mise à jour des modèles de dossiers (PV d'ouverture, Dossiers d'Appel d'Offres, Demandes de Propositions, Rapports d'évaluation)",
        route: { name: "Model_pv" }
      },
      {
        icon: "mdi-close-circle-outline",
        text: "Entreprises exclues de la commande publique",
        route: { name: "entreprises_exclues" }
      },
      {
        icon: "mdi-alpha-d-box-outline",
        text: "Mes dénonciations",
        route: { name: "mes_denonciations" }
      },
      {
        icon: "mdi-alpha-s-box-outline",
        text: "Sollicitation de conciliation ",
        route: { name: "mes_sollicitations" }
      },
    ],
    items: [
      {
        icon: "mdi-send-variant-outline",
        text: "Envoi des demandes à l'organe de contrôle pour approbations",
        route: { name: "ano"}
      },
      {
        icon: "mdi-clipboard-file",
        text: "Publication des Plans de Passation des Marchés",
        route: { name: "ppm" }
      },
      { icon: "mdi-bulletin-board", text: "Publication des Avis d'Appel à la Concurrence", route: { name: "notice" } },
      {
        icon: "mdi-file-document-multiple-outline",
        text: "Publication des dossiers de consultation (Appel d'Offres / Demande de Propositions / Sollicitation de Prix)",
        route: { name: "folder" }
      },
      {
        icon: "mdi-toolbox-outline",
        text: "Offres /Propositions /Plis ou Réponses aux Avis d'Appel à la Concurrence reçus (consulter et ou télécharger)",
        route: { name: "Offers" }
      },
      {
        icon: "mdi-server-security",
        text: "Création des séances publiques d'ouverture (Offres /Propositions /Plis)",
        route: { name: "Session" }
      },
      {
        icon: "mdi-card-bulleted-settings",
        text: "Création des séances d'évaluation (Offres /Propositions /Plis)",
        route: { name: "Evaluation" }
      },
      {
        icon: "mdi-ticket",
        text: "Création des séances plénières d'attribution des marchés",
        route: { name: "Attribution" }
      },
      {
        icon: "mdi-book-education-outline",
        text: " Transmission des projets de marchés/contrats / des PV de négociation aux consultants retenus",
        route: { name: "Contract" }
      }
    ],
    adminRoutes: [
      {
        icon: "mdi-account-plus",
        text: "Création de compte utilisateurs",
        route: { name: "UserAdd" }
      },
      { icon: "mdi-account-search", text: "Gestion des comptes utilisateurs", route: { name: "All_users" } },
      {
        icon: "mdi-file-document-multiple-outline",
        text: "Gestion des accès par rapport aux dossiers payants",
        route: { name: "OpFolder" }
      },
      {
        icon: "mdi-account-key-outline",
        text: "Abréviation/Acronyme",
        route: { name: "Access_management" }
      }
    ],

    // Routes pour Organe de Contrôle 
    autorityControlRoutes: [
      {
        icon: "mdi-alpha-p-box-outline",
        text: "ANO / Approbation pour les plans de passations de marchés (PPM)",
        route: { name: "ano_ppm" }
      },
      {
        icon: "mdi-alpha-a-box-outline",
        text: "ANO / Approbation pour les avis d'appel à concurrence",
        route: { name: "ano_avis" }
      },
      {
        icon: "mdi-alpha-a-box-outline",
        text: "ANO / Approbation pour les dossiers d'appel à concurrence",
        route: { name: "ano_dossier" }
      },
      {
        icon: "mdi-server-security",
        text: "Participation aux séances d'ouvertures des offres",
        route: { name: "participation_seance_ouv" }
      },
      {
        icon: "mdi-card-bulleted-settings",
        text: "Evaluations des offres",
        route: { name: "participation_seance_eval" }
      },
      {
        icon: "mdi-ticket",
        text: "Attributions des marchés",
        route: { name: "participation_seance_attrib" }
      },
      {
        icon: "mdi-close-circle-outline",
        text: "Entreprises exclues de la commande publique",
        route: { name: "entreprises_exclues" }
      },
      {
        icon: "mdi-alpha-s-box-outline",
        text: "Sollicitation de conciliation ",
        route: { name: "mes_sollicitations" }
      },
    ],

    // Routes pour Organe de Regulation 
    autorityRegulationRoutes: [
      {
        icon: "mdi-alpha-r-box-outline",
        text: "Les Recours",
        route: { name : "Reg_recours" }
      },
      {
        icon: "mdi-alpha-r-box-outline",
        text: "Liste des ppm approuvés",
        route: { name: "Reg_ppm" }
      },
      {
        icon: "mdi-alpha-r-box-outline",
        text: "Liste des avis approuvés",
        route: { name: "Reg_avis" }
      },
      {
        icon: "mdi-alpha-r-box-outline",
        text: "Liste des dossiers approuvés",
        route: { name: "Reg_dossier" }
      },
      {
        icon: "mdi-server-security",
        text: "Participation aux séances d'ouvertures des offres",
        route: { name: "RegSeanceOuv" }
      },
      {
        icon: "mdi-card-bulleted-settings",
        text: "Participation aux séances d'évaluations des offres",
        route: { name: "RegSeanceEval" }
      },
      {
        icon: "mdi-ticket",
        text: "Participation aux séances d'attributions des marchés",
        route: { name: "RegSeanceAttrib" }
      },
      {
        icon: "mdi-close-circle-outline",
        text: "Entreprises exclues de la commande publique",
        route: { name: "Reg_Exclusion" }
      },
      {
        icon: "mdi-format-list-group-plus",
        text: "Liste des demandes d'attestation de non exclusion",
        route: { name: "Reg_AttestationNonExclusion" }
      },
      {
        icon: "mdi-alpha-q-box-outline",
        text: "Liste des demandes de quitus de non redevance",
        route: { name: "Reg_quitus" }
      },
      {
        icon: "mdi-alpha-d-box-outline",
        text: "Liste des dénonciations",
        route: { name: "Reg_denonciation" }
      },
      {
        icon: "mdi-alpha-d-box-outline",
        text: "Liste des sollicitations de conciliation (Contentieux au cours de l'execution d'un marché public)",
        route: { name: "Reg_sollicitation" }
      },
    ],

    OtherPop: [
      {
        icon: "mdi-file-document-alert-outline",
        text: "Mes attestations des non exclusion",
        route: { name: "mes_attestations" }
      },
      {
        icon: "mdi-alpha-m-circle-outline",
        text: "Modèles de fiche de demande de quitus de non redevance",
        route: { name: "modele_fiche_quitus" }
      },
      {
        icon: "mdi-alpha-q-box-outline",
        text: "Mes quitus de non redevance",
        route: { name: "quitus_non_redevance" }
      },
      {
        icon: "mdi-alpha-d-box-outline",
        text: "Mes dénonciations",
        route: { name: "mes_denonciations" }
      },
      {
        icon: "mdi-alpha-s-box-outline",
        text: "Sollicitation de conciliation ",
        route: { name: "mes_sollicitations" }
      },
    ],
    PopOrgReg: [
    {
        icon: "mdi-alpha-m-box",
        text: "Ajouter un modèle de fiche de quitus de non redevance",
        route: { name: "Reg_modele_quitus" }
      },
    ],
     PopMembreCommission: [
      
    ],
    comRoutes: [
      {
        icon: "mdi-file-document-multiple-outline",
        text: "Consultation et téléchargement des dossiers de consultation (Appel d'Offres / Demande de Propositions / Sollicitation de Prix)",
        route: { name: "OpFolder" }
      },
      { 
        icon: "mdi-toolbox-outline", 
        text: "Consultation des Offres /Propositions /Plis ou Réponses aux Avis d'Appel à la Concurrence reçus", 
        route: { name: "Offers" } },
      { 
        icon: "mdi-server-security",
        text: "Consultation et participation à des séances publiques d'ouverture (Offres /Propositions /Plis)", 
        route: { name: "Session" } },
      {
        icon: "mdi-card-bulleted-settings",
        text: "Consultation et participation à des séances d'évaluation (Offres /Propositions /Plis)",
        route: { name: "Evaluation" }
      },
      { 
        icon: "mdi-ticket", 
        text: "Consultation et participation à des séances plénières d'attribution des marchés", 
        route: { name: "Attribution" } },
      {
        icon: "mdi-book-education-outline",
        text: "Consultation et participation à des séances de négociations des marchés/contrat.",
        route: { name: "Contract" }
      }
    ],
    opRoutes: [
      {
        icon: "mdi-file-document-multiple-outline",
        text: "Consultation et téléchargement des dossiers de consultation (Appel d'Offres / Demande de Propositions / Sollicitation de Prix)",
        route: { name: "OpFolder" }
      },
      { 
        icon: "mdi-toolbox-outline", 
        text: "Transmission des Offres /Propositions /Plis ou Réponses aux Avis d'Appel à la Concurrence", 
        route: { name: "Offers" } },
      {
        icon: "mdi-file-document-multiple",
        text: "Consultations et téléchargements des demandes d'éclaircissements",
        route: { name: "request" }
      },
      { icon: "mdi-account-supervisor-circle", text: "Consultation des visites de sites et téléchargement des Procès-Verbaux", route: { name: "visit" } },
      { icon: "mdi-devices", text: "Consultation et téléchargement des Procès-Verbaux des conférences préalables", route: { name: "meeting" } },
      { icon: "mdi-server-security", text: "Consultation des Procès-Verbaux des séances publiques d'ouvertures (Offres /Propositions /Plis)", route: { name: "Session" } },
      {
        icon: "mdi-book-education-outline",
        text: "Consultation et participation à des séances de négociations des marchés/contrats",
        route: { name: "Contract" }
      },
      {
        icon: "mdi-close-circle-outline",
        text: "Entreprises exclues de la commande publique",
        route: { name: "entreprises_exclues" }
      }
    ]
  }),
  created() {
    this.$store.dispatch("Auth/getAllConfigHome");
    let Virt = [];

    Virt = JSON.parse(localStorage.getItem("userData"));
    this.profile = Virt.profile.status;
    this.user_data = Virt;
  },
  computed: {
    ...mapGetters({
      infoHome: "Auth/get_all_cnfig_home"
    }),
    breadCrumbs() {
      let pathArray = this.$route.path.split("/");
      console.log(pathArray);
      pathArray.shift();
      const breadCrumbs = [];
      // needed to handle the intermediary entries for nested vue routes
      let breadcrumb = "";
      let lastIndexFound = 0;
      for (let i = 0; i < pathArray.length; ++i) {
        breadcrumb = `${breadcrumb}${"/"}${pathArray[i]}`;
        console.log(
          this.$route,
          Object.hasOwnProperty.call(this.$route.matched[i], "meta"),
          Object.hasOwnProperty.call(this.$route.matched[i].meta, "breadcrumb")
        );
        if (
          this.$route.matched[i] &&
          Object.hasOwnProperty.call(this.$route.matched[i], "meta") &&
          Object.hasOwnProperty.call(this.$route.matched[i].meta, "breadcrumb")
        ) {
          console.log(pathArray[i - (i - lastIndexFound)]);
          breadCrumbs.push({
            href:
              i !== 0 && pathArray[i - (i - lastIndexFound)]
                ? "/" + pathArray[i - (i - lastIndexFound)] + breadcrumb
                : breadcrumb,
            disabled: i + 1 === pathArray.length,
            text: this.$route.matched[i].meta.breadcrumb || pathArray[i]
          });
          lastIndexFound = i;
          breadcrumb = "";
        }
      }
      return breadCrumbs;
    }
  },
  methods: {
    ...mapActions({
      logOut: "Auth/logOut"
    }),

    getProfileBackground(profile) {
      const profileClasses = {
        1: 'profile-admin',
        2: 'profile-operator',
        3: 'profile-buyer',
        4: 'profile-commission',
        5: 'profile-regulation',
        6: 'profile-control'
      };
      return `profile-section ${profileClasses[profile] || 'profile-default'}`;
    },

    getProfilePrefix(profile) {
      const prefixes = {
        1: 'ADMIN',
        2: 'OP',
        3: 'AC',
        4: 'COM',
        5: 'GOUV',
        6: 'GOUV'
      };
      return prefixes[profile] || 'USER';
    }
  }
};
</script>

<style scoped>
.bg {
  background-color: #eae7fd;
}

/* Image de profil */
.profile-image {
  object-fit: cover;
  border-radius: 8px;
  margin: 8px;
}

/* Section profil */
.profile-section {
  padding: 16px;
  border-radius: 8px;
  margin: 8px;
  backdrop-filter: blur(8px);
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}

/* Couleurs par profil */
.profile-admin {
  background: linear-gradient(135deg, rgba(255, 235, 238, 0.9) 0%, rgba(255, 205, 210, 0.9) 100%);
  border-left: 4px solid #f44336;
}

.profile-operator {
  background: linear-gradient(135deg, rgba(232, 245, 233, 0.9) 0%, rgba(200, 230, 201, 0.9) 100%);
  border-left: 4px solid #4caf50;
}

.profile-buyer {
  background: linear-gradient(135deg, rgba(227, 242, 253, 0.9) 0%, rgba(179, 229, 252, 0.9) 100%);
  border-left: 4px solid #2196f3;
}

.profile-commission {
  background: linear-gradient(135deg, rgba(243, 229, 245, 0.9) 0%, rgba(225, 190, 231, 0.9) 100%);
  border-left: 4px solid #9c27b0;
}

.profile-regulation {
  background: linear-gradient(135deg, rgba(255, 243, 224, 0.9) 0%, rgba(255, 224, 178, 0.9) 100%);
  border-left: 4px solid #ff9800;
}

.profile-control {
  background: linear-gradient(135deg, rgba(224, 242, 241, 0.9) 0%, rgba(52, 46, 216, 0.9) 100%);
  border-left: 4px solid #005c96;
}

/* Barre de statut connexion */
.online {
  background: linear-gradient(90deg, #4CAF50, #8BC34A);
  height: 4px;
  width: 100%;
}

.offline {
  background: linear-gradient(90deg, #FF9800, #FF5722);
  height: 4px;
  width: 100%;
}

/* Assurer la lisibilité */
.profile-section ::v-deep .v-card {
  background: transparent !important;
}

.profile-section ::v-deep .v-card-text {
  color: rgba(0, 0, 0, 0.87) !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.8);
}

.profile-section ::v-deep .text-caption {
  color: rgba(0, 0, 0, 0.8) !important;
  font-weight: 500;
}

.profile-section ::v-deep .font-weight-bold {
  color: rgba(0, 0, 0, 0.9) !important;
}

.profile-section ::v-deep .v-divider {
  border-color: rgba(0, 0, 0, 0.2) !important;
}

/* Responsive */
@media (max-width: 960px) {
  .profile-image {
    height: 180px !important;
  }
  
  .profile-section {
    padding: 12px;
    min-height: 100px;
  }
}
</style>